<template>
    <div class="form-control" style="padding: 0;" :id="id">
        <QuillEditor :toolbar="[
                [{ 'header': [4, false, 6] }],
                ['bold', 'italic'].reverse(),
                ['link', 'image'].reverse(),
                [{ 'list': 'ordered'}, { 'list': 'bullet' }],
            ]" v-model:content="contentModel" :placeholder="placeholder" />
    </div>
    <span class="invalid-hint" :for="id">{{ invalidHint }}</span>
</template>

<script>
import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css'
import 'bootstrap/dist/css/bootstrap.rtl.min.css'

export default {
    name: "WYSIWYG",
    components: { QuillEditor },
    mixins: [],
    props: ['content','placeholder','id','invalidHint'],
    emits: ['update:content'],
    data: () => ({
        // content: null
    }),
    computed: {
        contentModel: {
            get() {
                return this.content
            },
            set(value) {
                this.$emit('update:content', value)
            }
        }
    }
}

</script>

<style lang="less">
.ql-toolbar {
    border-top: 0!important;
    border-left: 0!important;
    border-right: 0!important;
}
.ql-container {
    border-bottom: 0!important;
    border-left: 0!important;
    border-right: 0!important;

    height: fit-content;

    .ql-tooltip {
        &,& * {
            direction: ltr;
        }
    }

    .ql-editor {
        min-height: 100px;
        height: 300px;
        max-height: 200vh;
        resize: vertical;

        &::before {
            text-align: right;
            font-style: normal!important;
        }

        h4 {
            font-size: 1.9em;
        }
        p {
            font-size: 1.3em;
        }
        h6 {
            font-size: 1em;
        }
    }
}

.ql-editor *, .ql-toolbar {
    direction: rtl;
    text-align: right!important;
}

.ql-toolbar {
    .ql-picker-label {
        direction: ltr;
    }
}

.ql-editor li {
    padding: 0 1.5em 0 0!important;

    &::before {
        margin-right: -1.5em!important;
        margin-left: 0.3em!important;
    }
}

</style>